import { render } from "./RequestCard.vue?vue&type=template&id=5d1929d5&scoped=true&ts=true"
import script from "./RequestCard.vue?vue&type=script&lang=ts"
export * from "./RequestCard.vue?vue&type=script&lang=ts"

import "./RequestCard.vue?vue&type=style&index=0&id=5d1929d5&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1929d5"]])

export default __exports__